
































import Vue from 'vue';

import store from '@/store';
import { BaseOrganization } from '@/models';

import BottomActionBar from '@/components/utils/BottomActionBar.vue';
import OrganizationSettingsEditor from '@/components/OrganizationSettingsEditor.vue';

export default Vue.extend({
  components: {
    BottomActionBar,
    OrganizationSettingsEditor
  },

  props: {
    organizationId: Number
  },

  data() {
    return {
      dirty: false,
      updatedModel: null as null | BaseOrganization
    };
  },

  computed: {
    organization(): BaseOrganization {
      return store.state.org.basic;
    }
  },

  methods: {
    handleChange({
      dirty,
      model
    }: {
      dirty: boolean;
      model: BaseOrganization;
    }) {
      this.dirty = dirty;
      this.updatedModel = model;
    },

    async save() {
      // Gatekept by dirty flag
      if (this.updatedModel == null) {
        return;
      }
      await store.dispatch.org.updateOrganization(this.updatedModel);

      this.exit();
    },

    exit() {
      this.$router.push({
        name: 'Organization',
        params: {
          organizationId: `${this.organization.organizationId}`
        }
      });
    }
  }
});
